import React from 'react';
import { getActivePayerList } from 'api/credentialing';
import { TKlarityPayer } from 'types/credentialing';

let globalData: TKlarityPayer[] = [];

// `enabled` gates the fetch so callers that depend on async-loaded `states` (e.g. the group
// payer picker) can wait until those states have arrived instead of fetching all payers first.
// The fetch is keyed on the states' content so a new array with the same states won't refetch.
// providerId（#19）：按该 provider 的执照返回 available / unavailableReason。带 providerId 的结果因人而异，
// 不写进、也不读模块级缓存，避免 group 里切换 provider 时串用别人的可选性
const usePayerOptions = (
    states?: string[],
    enabled = true,
    providerId?: number | string,
): [TKlarityPayer[], boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<TKlarityPayer[]>(providerId ? [] : globalData);

    const statesKey = Array.isArray(states) ? states.join(',') : '';

    const fetchData = React.useCallback(async () => {
        if (!enabled) return;
        setLoading(true);
        try {
            const result = await getActivePayerList(statesKey ? statesKey.split(',') : undefined, providerId);
            if (!result.error) {
                const list: TKlarityPayer[] = result?.data?.data || [];
                if (!providerId) globalData = list;
                setData(list);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [enabled, statesKey, providerId]);

    // 换了 provider 先清空，别让上一个人的可选性在新列表回来前闪现
    const prevProviderRef = React.useRef(providerId);
    React.useEffect(() => {
        if (prevProviderRef.current !== providerId) {
            prevProviderRef.current = providerId;
            setData([]);
        }
        fetchData();
    }, [fetchData, providerId]);

    return [data, loading, fetchData];
};

export default usePayerOptions;
